import { PhosphorLayout, PhosphorClipboard, PhosphorCopy } from "components/Atoms/PhosphorIcon";
import React from "react";
import { RightClickMenuItem } from "./RightClickMenu";
import ConfirmCopyModal from "components/modals/ConfirmCopyModal";
import { useOpenGroundTransportSidePanel } from "components/SidePanel/GroundTransport/GroundSidePanel";
import { useOpenFlightSidePanel } from "components/SidePanel/Flight/FlightSidePanel";
import { useOpenTrainSidePanel } from "components/SidePanel/Train/TrainSidePanel";

interface RightMenuOptions {
  duplicate?: {
    canDuplicate: boolean;
    duplicateFn: () => Promise<server.dto.ApiResponseWrapper<number>>;
    sidePanelToOpen: "flight" | "groundTransport" | "train";
    invalidateCache: () => void;
  }
}

export const rightMenuForSidePanel = (detailUrl: string, opts?: RightMenuOptions): RightClickMenuItem[] => {
  const isMac = /mac/i.test(navigator.userAgent);

  const items: RightClickMenuItem[] = [{
    type: "item",
    label: RESX.Buttons.DetailView,
    icon: <PhosphorLayout />,
    onClick: () => {
      window.location.href = detailUrl;
    }
  }, {
    type: "item",
    label: RESX.Buttons.OpenInNewTab,
    icon: <div className="text-light">{isMac ? "Cmd" : "Ctrl"} + Click</div>,
    onClick: () => {
      window.open(detailUrl, "_blank");
    }
  }, {
    type: "item",
    label: RESX.Buttons.CopyLink,
    icon: <PhosphorClipboard />,
    onClick: () => {
      navigator.clipboard.writeText(detailUrl);
    }
  }]

  const extraItems: RightClickMenuItem[] = [];

  if (opts?.duplicate && opts.duplicate.canDuplicate) {
    extraItems.push({
      type: "item",
      label: RESX.Buttons.DuplicateItem,
      icon: <PhosphorCopy />,
      onClick: () => { },
      renderConfirm: (onClose: () => void) => <ConfirmCopyModalForRightClick
        duplicateFn={opts.duplicate.duplicateFn}
        onClose={onClose}
        sidePanelToOpen={opts.duplicate.sidePanelToOpen}
        invalidateCache={opts.duplicate.invalidateCache}
      />
    });
  }

  if (extraItems.length > 0) {
    items.push({
      type: "separator",
    });
    items.push(...extraItems);
  }

  return items;
}

interface ConfirmCopyModalForRightClickProps {
  duplicateFn: () => Promise<server.dto.ApiResponseWrapper<number>>;
  onClose: () => void;
  sidePanelToOpen: "flight" | "groundTransport" | "train";
  invalidateCache: () => void;
}

const ConfirmCopyModalForRightClick = (props: ConfirmCopyModalForRightClickProps) => {
  const openFlightSidePanel = useOpenFlightSidePanel();
  const openGroundTransportSidePanel = useOpenGroundTransportSidePanel();
  const openTrainSidePanel = useOpenTrainSidePanel();

  return <ConfirmCopyModal
    isOpen={true}
    apiCall={props.duplicateFn}
    onClose={props.onClose}
    onSuccess={(itemId) => {
      if (props.sidePanelToOpen === "flight") {
        openFlightSidePanel(itemId);
      } else if (props.sidePanelToOpen === "groundTransport") {
        openGroundTransportSidePanel(itemId);
      } else if (props.sidePanelToOpen === "train") {
        openTrainSidePanel(itemId);
      }
      props.invalidateCache();
    }}
  />
}